import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef } from "react";
import { useWidgetSelector, useWidgetStore } from "../../../store/store";
import { submitReferral } from "../../../store/flows";
import { EffektButton, EffektButtonVariant } from "../../../../EffektButton/EffektButton";
import { selectReferral, setOtherText } from "../../../store/actions";
import { State } from "../../../store/state";
import { ReferralData } from "../../../types/Temp";
import { WidgetPane3ReferralsProps } from "../../../types/WidgetProps";
import { widgetAsksForReferrals } from "../../../store/widgetApi";
import panes from "../../panes/Panes.module.scss";
import styles from "./Referrals.module.scss";

// The "other" answer is saved once the donor pauses typing, not on every keystroke
const OTHER_TEXT_DEBOUNCE_MS = 600;
const OTHER_REFERRAL_ID = 10;
export const Referrals: React.FC<{
  text: WidgetPane3ReferralsProps;
}> = t0 => {
  const $ = _c(28);
  const {
    text
  } = t0;
  const store = useWidgetStore();
  const {
    dispatch
  } = store;
  const referrals = useWidgetSelector(_temp);
  const selectedReferrals = useWidgetSelector(_temp2);
  const otherText = useWidgetSelector(_temp3);
  const pendingOtherText = useRef(null);
  let t1;
  if ($[0] !== store) {
    t1 = value => {
      submitReferral(store, value.trim() !== "" ? {
        referralID: OTHER_REFERRAL_ID,
        active: true,
        comment: value
      } : {
        referralID: OTHER_REFERRAL_ID,
        active: false
      });
    };
    $[0] = store;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const submitOtherText = t1;
  let t2;
  let t3;
  if ($[2] !== submitOtherText) {
    t2 = () => () => {
      if (pendingOtherText.current) {
        clearTimeout(pendingOtherText.current.timer);
        submitOtherText(pendingOtherText.current.text);
      }
    };
    t3 = [submitOtherText];
    $[2] = submitOtherText;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  if (!widgetAsksForReferrals()) {
    return null;
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      position: "relative",
      left: "-40px",
      marginTop: "1.5rem",
      paddingBottom: "0.5rem"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      position: "absolute",
      left: "0",
      top: "0"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div style={t4}><svg height="2" width="576" style={t5}><g fill="none" stroke="currentcolor" strokeWidth="1"><path strokeDasharray="12,12" strokeDashoffset="6" d="M0 1 l576 0" /></g>Sorry, your browser does not support inline SVG.</svg></div>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== text.referrals_title) {
    t7 = <h2 className={panes.paneTitle}>{text.referrals_title}</h2>;
    $[8] = text.referrals_title;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== dispatch || $[11] !== referrals || $[12] !== selectedReferrals || $[13] !== store) {
    t8 = referrals?.filter(_temp4).map(ref_0 => <EffektButton squared={true} variant={EffektButtonVariant.SECONDARY} cy={`referral-button-${ref_0.id}`} key={ref_0.id} selected={selectedReferrals.includes(ref_0.id)} useCheckmark={true} onClick={e => {
      if (selectedReferrals.includes(ref_0.id)) {
        const refData = {
          referralID: ref_0.id,
          active: false
        };
        dispatch(selectReferral(refData));
        submitReferral(store, refData);
      } else {
        const refData_0 = {
          referralID: ref_0.id,
          active: true
        };
        dispatch(selectReferral(refData_0));
        submitReferral(store, refData_0);
      }
      e.currentTarget.blur();
    }}>{ref_0.name}</EffektButton>);
    $[10] = dispatch;
    $[11] = referrals;
    $[12] = selectedReferrals;
    $[13] = store;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <div className={styles.buttonsWrapper}>{t8}</div>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== dispatch || $[18] !== submitOtherText) {
    t10 = e_0 => {
      const value_0 = e_0.currentTarget.value;
      dispatch(setOtherText(value_0));
      if (pendingOtherText.current) {
        clearTimeout(pendingOtherText.current.timer);
      }
      pendingOtherText.current = {
        text: value_0,
        timer: setTimeout(() => {
          pendingOtherText.current = null;
          submitOtherText(value_0);
        }, OTHER_TEXT_DEBOUNCE_MS)
      };
    };
    $[17] = dispatch;
    $[18] = submitOtherText;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== otherText || $[21] !== t10 || $[22] !== text.other_referral_input_placeholder) {
    t11 = <input className={styles.textInput} data-cy="referral-text-input" type="text" placeholder={text.other_referral_input_placeholder} value={otherText} onChange={t10} />;
    $[20] = otherText;
    $[21] = t10;
    $[22] = text.other_referral_input_placeholder;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t7 || $[26] !== t9) {
    t12 = <div>{t6}{t7}{t9}{t11}</div>;
    $[24] = t11;
    $[25] = t7;
    $[26] = t9;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};
function _temp(state) {
  return state.referrals.referrals;
}
function _temp2(state_0) {
  return state_0.referrals.selectedReferrals;
}
function _temp3(state_1) {
  return state_1.referrals.otherText;
}
function _temp4(ref) {
  return ref.id !== OTHER_REFERRAL_ID;
}